/**
 * @Author: Anandp
 * @Date:   2024-04-17 18:40:49
 * @Last Modified by:   Anandp
 * @Last Modified time: 2024-12-23 15:48:09
 */
import React, { createContext, useContext, useState } from "react";

const TeamContext = createContext();

export const TeamProvider = ({ children }) => {
  const [selectedTeamId, setSelectedTeamId] = useState([]);
  const [selectedInviteId, setSelectedInviteIds] = useState([]);
  const [dashboardStatusState, setDashboardStatusState] = useState(false);
  const [hrAnalyticsStatusState, setHrAnalyticsStatusState] = useState(false);
  const [applyTeams, setApplyTeams] = useState(false);
  const [teamInfo, setTeamInfo] = useState([]);
  const [orgLevel, setOrgLevel] = useState(false);
  const [orgName, setOrgName] = useState(null);

  const setTeamId = (teamId, teamName, divisionName) => {
    // setSelectedTeamId([]);
    // setTeamInfo([]);
    const stringifiedTeamId = String(teamId); // Convert teamId to string for consistent comparison
  
    // Check if the teamId already exists in the selectedTeamId state
    setSelectedTeamId((prevIds) => {
      const updatedIds = new Set(prevIds.map(id => String(id))); // Ensure all IDs are strings
      if (updatedIds.has(stringifiedTeamId)) {
        // If teamId already exists, return the previous state (no changes)
        return prevIds;
      } else {
        // If teamId does not exist, add it to the state
        return [...prevIds, teamId];
      }
    });
  
    // Check if the teamId already exists in the teamInfo state
    setTeamInfo((prevTeamInfo = []) => {
      const safeArray = Array.isArray(prevTeamInfo) ? prevTeamInfo : [];
      const normalizedId = String(stringifiedTeamId);

      const teamExists = safeArray.find(
        (team) => team.teamId === normalizedId
      );
      
      if (teamExists) {
        // If teamId already exists, return the previous state
        // Update only if teamName is empty
        // console.log("teamId:", teamId, "teamName:", teamName, "divisionName:", divisionName);

        return safeArray.map((team) =>
          team.teamId === normalizedId &&
          (!team.teamName || team.teamName === "Unknown")
            ? { ...team, teamName, divisionName }
            : team
        );
      } else {
        const matchingTeam = Array.isArray(teamInfo)
        ? teamInfo.find(team => String(team.teamId) === normalizedId)
        : undefined;

        // console.log("teamName from matching team", matchingTeam?.teamName);

        if (
          (!teamName || teamName === "Unknown" || teamName === "unknown") &&
          matchingTeam?.teamName
        ) {
          teamName = matchingTeam.teamName;
        }
        // If teamId does not exist, add the new team info
        return [
          ...safeArray,
          { teamId: normalizedId, teamName, divisionName },
        ];
      }
    });
  };
  const setSelectedInviteId = (inviteID,teamId, pulse) => {
    setSelectedInviteIds((prevIds) => [inviteID]);
    // setTeamInfo((prevTeamInfo) => [
    //   ...prevTeamInfo,
    //   { teamId, inviteID, pulse },
    // ]);
  };
  const setDashboardStatus = (status,teamId, pulse) => {
    // setDashboardStatusState(status);
    setDashboardStatusState(status);
    // setTeamInfo((prevTeamInfo) => [
    //   ...prevTeamInfo,
    //   { teamId, inviteID, pulse },
    // ]);
  };
  const setHrAnalyticsStatus = (status,teamId, pulse) => {
    // setDashboardStatusState(status);
    setHrAnalyticsStatusState(status);
    // setTeamInfo((prevTeamInfo) => [
    //   ...prevTeamInfo,
    //   { teamId, inviteID, pulse },
    // ]);
  };
  const removeTeamId = (teamId) => {
    setSelectedTeamId((prevIds) => prevIds.filter((id) => id !== teamId));
    setTeamInfo((prevTeamInfo) =>
      prevTeamInfo.filter((team) => team.teamId !== teamId)
    );
  };

  const removeAllTeamIds = () => {
    setSelectedTeamId([]);
    setTeamInfo([]);
  };

  const settingOrgLevelStateTrue = () => {
    setOrgLevel(true);
  };

  const settingOrgLevelStateFalse = () => {
    setOrgLevel(false);
  };

  const settingOrgName = (name) => {
    setOrgName(name);
  };

  const applySelectedTeams = () => {
    setApplyTeams(true);
  };

  const unApplySelectedTeams = () => {
    setApplyTeams(false);
  };

  return (
    <TeamContext.Provider
      value={{
        selectedTeamId,
        setTeamId,
        removeTeamId,
        applyTeams,
        teamInfo,
        setTeamInfo,
        applySelectedTeams,
        unApplySelectedTeams,
        removeAllTeamIds,
        settingOrgLevelStateTrue,
        settingOrgLevelStateFalse,
        orgLevel,
        settingOrgName,
        orgName,
        selectedInviteId,
        setSelectedInviteId,
        dashboardStatusState,
        setDashboardStatus,
        hrAnalyticsStatusState,
        setHrAnalyticsStatus
      }}
    >
      {children}
    </TeamContext.Provider>
  );
};

export const useTeam = () => {
  return useContext(TeamContext);
};
